/**
 * Experiments created on Petri should be listed here.
 *
 * #### Scopes
 *
 * Any new created specs should be conducted via centralized conduction.
 *
 * This means that they should be created with the following scopes:
 *
 * |            | Scope                                              |
 * | :-         | :-                                                 |
 * | Backoffice | `bm-apps-14bcded7-0066-7c35-14d7-466cb3f09103`     |
 * | Viewer     | `viewer-apps-14bcded7-0066-7c35-14d7-466cb3f09103` |
 */
export const EXPERIMENTS = {
    USE_WARMUP_STATE_IN_FEED: 'specs.wixBlog.UseWarmupStateInFeed',
    USE_WARMUP_STATE_IN_POST_LIST: 'specs.wixBlog.UseWarmupStateInPostList',
    /**
     * https://bo.wix.com/petri/experiments/2521350
     * - Allow trailing slash in Post Composer SEO panel
     */
    ALLOW_SLUG_TRAILING_SLASH: 'specs.wixBlog.AllowSlugTrailingSlash',
    /**
     * https://bo.wix.com/petri/experiments/2565957
     * - use blog-apps-test tag to test apps before add them to live app collection https://bo.wix.com/tag-manager/tag/2bbb6e0b-2cff-4902-a45e-e5fc581ae94f/apps
     **/
    BLOG_APPS_TEST_TAG: 'specs.wixBlog.BlogAppsTestTag',
    /**
     * https://bo.wix.com/petri/experiments/2759147
     * - Use Post editor Ai Tools Panel
     */
    POST_EDITOR_AI_TOOLS: 'specs.wixBlog.PostEditorAiTools',
    /**
     * https://bo.wix.com/petri/experiments/3008775
     * - Used to navigate in wordpress blogs, that need post links to be on the site root (wix.com/blog/photography/2019/01/post)
     **/
    USE_SITE_ROOT_LINKS: 'specs.wixBlog.UseSiteRootLinks',
    /**
     * https://bo.wix.com/petri/experiments/2999108
     * Adds "Post Radius" control in Post List / Feed setting panels
     **/
    POST_ROUNDED_CORNERS: 'specs.wixBlog.PostRoundedCorners',
    /**
     * https://bo.wix.com/petri/experiments/3043681
     * Limit pagination to 100 pages due to BE limitations
     */
    LIMIT_PAGINATION_TO_100_PAGES: 'specs.wixBlog.LimitPaginationTo100Pages',
};
//# sourceMappingURL=experiments.js.map